import * as THREE from "three";
import { Curves } from "three/examples/jsm/curves/CurveExtras";
import { addEffect } from "react-three-fiber";
import create from "zustand";
import * as audio from "./audio";
import gameStates from "./util/gameStates";

let guid = 1;

const [useStore, api] = create((set, get) => {
  return {
    gameState: gameStates.INTRO,
    prompts: null,
    currentPromptID: "eHLeYJ5merkAfk6fRNhK",
    currentAnswers: [],
    debug: {
      orbitControls: false,
      fixedCameraControls: true,
      arrows: false,
      logging: false,
      ambient: false,
      blur: 0.0,
    },
    playerWorldPosition: undefined,
    sound: true,
    camera: undefined,
    controls: {
      up: false,
      down: false,
      right: false,
      left: false,
    },
    mutation: {
      startTime: Date.now(),
      scale: 15,

      globeRadius: 100,
      enableShadows: true,

      angle: new THREE.Vector3(0, 3, -3),
      zoom: 50,
      fov: 90,

      hits: false,
      binormal: new THREE.Vector3(),
      normal: new THREE.Vector3(),
      clock: new THREE.Clock(false),
      mouse: new THREE.Vector2(-250, 50),

      // Re-usable objects
      dummy: new THREE.Object3D(),
      ray: new THREE.Ray(),
      box: new THREE.Box3(),
    },

    debugActions: {
      set(key, val) {
        set((state) => ({
          debug: { ...state.debug, [key]: val },
        }));
      },
      toggle(key) {
        set((state) => ({
          debug: { ...state.debug, [key]: !state.debug[key] },
        }));
      },
    },

    actions: {
      init(camera) {
        const { mutation, actions } = get();

        set({ camera });
        mutation.clock.start();

        camera.lookAt(new THREE.Vector3(0, mutation.globeRadius, 0));

        // actions.toggleSound(get().sound)

        window.addEventListener("keydown", (e) => actions.handleKey(e, true));
        window.addEventListener("keyup", (e) => actions.handleKey(e, false));

        // addEffect(() => {
        //     const { rocks, enemies } = get()

        //     const time = Date.now()
        // });
      },
      setPlayerWorldPosition(pos) {
        set({ playerWorldPosition: pos });
      },
      toggleSound(sound = !get().sound) {
        // set({ sound })
        // playAudio(audio.engine, 1, true)
        // playAudio(audio.engine2, 0.3, true)
        // playAudio(audio.bg, 1, true)
      },
      setDebugConfig(config) {
        set((state) => ({ debug: { ...state.debug, ...config } }));
      },
      updateMouse({ clientX: x, clientY: y }) {
        get().mutation.mouse.set(
          x - window.innerWidth / 2,
          y - window.innerHeight / 2
        );
      },
      setVisualizerArray(visualizerArray) {
        set((state) => ({ visualizerArray }));
      },
      setGameState(gameState) {
        set((state) => ({ gameState }));
      },
      setPrompts(prompts) {
        console.log(prompts);
        set((state) => ({ prompts }));
      },
      setCurrentAnswers(currentAnswers) {
        console.log(currentAnswers);
        set((state) => ({ currentAnswers }));
      },
      setCurrentPromptID(currentPromptID) {
        console.log(currentPromptID);
        set((state) => ({ currentPromptID }));
      },
      handleKey(e, isPressed) {
        switch (e.key) {
          case "ArrowUp":
          case "w":
            set((state) => ({
              controls: { ...state.controls, up: isPressed },
            }));
            break;

          case "ArrowRight":
          case "d":
            set((state) => ({
              controls: { ...state.controls, right: isPressed },
            }));
            break;

          case "ArrowDown":
          case "s":
            set((state) => ({
              controls: { ...state.controls, down: isPressed },
            }));
            break;

          case "ArrowLeft":
          case "a":
            set((state) => ({
              controls: { ...state.controls, left: isPressed },
            }));
            break;

          // case 'Control':
          // case ' ':
          //     this.actions.brake = true
          //     break

          // case 'Shift':
          //     this.actions.boost = true
          //     break

          // case ' ':
          //     this.jump(true)
          //     break
        }
      },
    },
  };
});

function playAudio(audio, volume = 1, loop = false) {
  // if (api.getState().sound) {
  //   audio.currentTime = 0
  //   audio.volume = volume
  //   audio.loop = loop
  //   audio.play()
  // } else audio.pause()
}

export default useStore;
export { audio, playAudio };
